import React, { CSSProperties } from "react";

export default function IconTeam(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				d="M12 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6m6.75 1.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m-13.5 0a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m2.25 7.49A1.5 1.5 0 0 1 9 10.5h6a1.5 1.5 0 0 1 1.5 1.5v4.5a4.5 4.5 0 1 1-9 0zM6 12q.01-.83.4-1.5H3A1.5 1.5 0 0 0 1.5 12v3.75a3.75 3.75 0 0 0 5.15 3.48A6 6 0 0 1 6 16.5zm12 0v4.5q-.02 1.49-.65 2.73a3.75 3.75 0 0 0 5.15-3.48V12a1.5 1.5 0 0 0-1.5-1.5h-3.4q.39.67.4 1.5"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
